import {
  TableHeader,
  TableHeaderCell,
  TableRow,
  TableSortIndicator,
  VisuallyHidden
} from '@vtex/shoreline'
import { t } from 'i18next'

import { useShowWalletOriginsColumn } from '~/modules/retailMedia/hooks/useShowWalletOrigins'

import styles from './styles.module.css'

const getSortIndicatorDirection = (
  columnKey: string,
  activeSortKey: string,
  activeSortDirection: string
): 'asc' | 'desc' | null => {
  if (activeSortKey !== columnKey) return null

  return activeSortDirection === 'ASC' ? 'asc' : 'desc'
}

type CheckingAccountTableHeaderProps = {
  showRechargeColumn: boolean
  activeSortKey: string
  activeSortDirection: string
  onSort: (data: OnSortProps) => void
}

export const CheckingAccountTableHeader = ({
  showRechargeColumn,
  activeSortKey,
  activeSortDirection,
  onSort
}: CheckingAccountTableHeaderProps) => {
  const showOriginsColumn = useShowWalletOriginsColumn()

  return (
    <TableHeader>
      <TableRow>
        {showOriginsColumn ? (
          <TableHeaderCell className={styles.chevronHeader}>
            <VisuallyHidden>{t('rm:wallet.list.expandOrigins')}</VisuallyHidden>
          </TableHeaderCell>
        ) : null}
        <TableHeaderCell
          className={styles.accountHeader}
          sortable
          onClick={() => onSort({ key: 'name' })}
        >
          {t('rm:wallet.table.column.title.account')}
          <TableSortIndicator
            sorted={getSortIndicatorDirection(
              'name',
              activeSortKey,
              activeSortDirection
            )}
          />
        </TableHeaderCell>
        <TableHeaderCell
          className={styles.balanceHeader}
          sortable
          onClick={() =>
            onSort({ key: 'balance', sortInitialDirection: 'DESC' })
          }
        >
          {t('rm:wallet.table.column.title.availableBalance')}
          <TableSortIndicator
            sorted={getSortIndicatorDirection(
              'balance',
              activeSortKey,
              activeSortDirection
            )}
          />
        </TableHeaderCell>
        {showOriginsColumn ? (
          <TableHeaderCell className={styles.originsCell}>
            {t('rm:wallet.table.column.title.origins')}
          </TableHeaderCell>
        ) : null}
        {showRechargeColumn ? (
          <TableHeaderCell>
            {t('rm:wallet.table.column.title.recharge')}
          </TableHeaderCell>
        ) : null}
        <TableHeaderCell className={styles.actionHeader}>
          <VisuallyHidden>{t('rm:wallet.list.viewWallet')}</VisuallyHidden>
        </TableHeaderCell>
      </TableRow>
    </TableHeader>
  )
}
